import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { requireBackoffice } from '../auth/guard.ts'
import { numericIdParam } from './params.ts'
import { rootRoute } from './root.tsx'

// The kit's own record. Loaded with useQuery and not a loader: the 404 has to stay an
// in-page message rather than RouteError's full screen.

export const kitDetailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/kits/$id',
  params: numericIdParam,
  beforeLoad: requireBackoffice,
  component: lazyRouteComponent(() => import('../pages/kit-detail.tsx')),
})

/** The record as a link target, with the id its path requires. */
export function kitCardLink(gatewayId: number) {
  return { to: kitDetailRoute.to, params: { id: gatewayId } } as const
}
